import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateRoomGuests } from '../../../../../actions/Booking';

import RoomHeader from '../../Card/CardRoom';
import Image from '../../../atoms/image/Image';
import { getOccupancyLabel } from '../../../../../utils/Room';
import RoomGuest from './roomGuest';
import BtnEdit from '../../../atoms/btn/btnEdit';
import BtnSave from '../../../atoms/btn/btnSave';

const MBRoom = (props, context) => {
  const {
    children, className, room, roomIndex, locator, booking,
  } = props;
  const [roomGuests, setroomGuests] = useState(room.occupants || []);
  const [isReadOnly, setReadOnly] = useState(true);
  const [error, setError] = useState(false);
  const { occupants } = room;

  const guestUpdate = (ev, index) => {
    if (ev) {
      occupants[index] = ev;
    }
  };
  const onClickUpdateRoomGuests = () => {
    if (!error) {
      setReadOnly(true);
      const result = props.updateRoomGuests({
        locator,
        email: booking.cli_email,
        defaultName: booking.main_occupant_name,
        occupants: roomGuests,
        roomIndex,
      });
      result.then((res) => {
        if (res.successMessage.update_ok) {
          setroomGuests(res.body.occupancy);
        } else {
          // handle error
        }
      });
    }
  };
  const hasError = (ev) => {
    const findError = Object.values(ev).find((el) => el);
    setError(!!findError);
  };
  return (
          <div className={` ${className || ''}`}>
            <RoomHeader
                    title={room.room.name}
                    roomIndex={roomIndex + 1}
                    guests={getOccupancyLabel(room.occupancy, context)}
                    className="text-lg"
            />
            <div className="flex flex-wrap md:flex-nowrap mb-4">
              <div className="flex-grow-default flex flex-wrap md:flex-nowrap">
                <div className="w-full sm:w-32">
                  <Image
                      img={room.room.photos.length > 0
                      && room.room.photos[0].url
                        ? room.room.photos[0].url : ''}
                      alt={room.room.name}
                      className="w-full"
                      />
                </div>
                <div className="mx-2 flex flex-wrap flex-grow-default">
                  {roomGuests.map((guest, guestIndex) => (
                          <RoomGuest
                                  guest={guest}
                                  guestIndex={guestIndex}
                                  roomIndex={roomIndex}
                                  key={guestIndex}
                                  isReadOnly={isReadOnly}
                                  guestUpdate={(ev) => guestUpdate(ev, guestIndex)}
                                  hasError={hasError}
                          />
                  ))}
                </div>
              </div>
            </div>
            <div className="flex justify-end -mx-2">
              {!isReadOnly && <BtnSave onClick={onClickUpdateRoomGuests} className="px-2"/>}
              <BtnEdit onClick={() => setReadOnly(!isReadOnly)} className="px-2"/>
            </div>
            {children}
          </div>
  );
};

MBRoom.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  locator: state.booking.book_locator,
  lang: state.i18nState.lang,
});

const mapDispatchToProps = (dispatch) => ({
  updateRoomGuests: (payload) => dispatch(updateRoomGuests(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MBRoom);
